/**
 * Helper functions to format content for download.
 *
 */
export default function createTabDelimitedInsilico(seqName, ftrName, data) {
  let content = `DATE_CREATED,${new Date(Date.now()).toString()},,,\n`;
  content += ',,,,\n';
  content += `SEQUENCE_NAME,${seqName},,,\n`;
  content += `FEATURE_NAME,${ftrName},,,\n`;
  content += ',,,,\n';
  content += 'COLUMN_INDEX,REF,ALT,VALUE,\n';
  data.forEach(line => {
    const splitLine = line.split(',');
    const colNum = splitLine[0];
    const ref = splitLine[1];
    const alt = splitLine[2];
    const value = Number(splitLine[3]);
    content += `${colNum},${ref},${alt},${value},\n`;
  });
  return content;
}
